import React from 'react'
import { List, ListItem, ListItemSecondaryAction, ListItemText, Stack, Switch } from '@mui/material'

import { HiChevronRight } from 'react-icons/hi2'
import { useDevMode } from '@plug-core/state'
import { useNavigate } from 'react-router-dom'
import { ROUTES } from '@utils/routes'

const DeveloperSettings = () => {
  const { networks, activeNetwork, devEnabled, setDevModeEnabled } = useDevMode()

  const navigate = useNavigate()

  return (
    <>
      <Stack
        bgcolor={(theme) => theme.palette.background.paper}
        spacing={2}
        mx={2}
        borderRadius={1}
      >
        <List>
          <ListItem>
            <ListItemText primary="Test Mode" secondary="Applies to balances and app connections" />
            <ListItemSecondaryAction>
              <Switch
                checked={devEnabled}
                onChange={(e) => setDevModeEnabled(e.target.checked)}
                color="success"
              />
            </ListItemSecondaryAction>
          </ListItem>

          <ListItem onClick={() => navigate(ROUTES.DEVELOPER_SETTINGS_NETWORKS)}>
            <ListItemText
              primary="Network"
              secondary={networks[activeNetwork || '']?.name || 'Not Set'}
            />
            <ListItemSecondaryAction>
              <HiChevronRight />
            </ListItemSecondaryAction>
          </ListItem>
        </List>
      </Stack>
    </>
  )
}

export default DeveloperSettings
